import { render, staticRenderFns } from "./RemoveModal.vue?vue&type=template&id=a759d5e8"
import script from "./RemoveModal.vue?vue&type=script&lang=js"
export * from "./RemoveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports